/* eslint-disable */
import type { RatePlan } from "../../../../franklin/rate_plan.pb";
import type { Region } from "../../../../franklin/region.pb";
import type { BusinessMetadata, Feature } from "../../../cashstorefronts/api/BusinessProfile.pb";
import type { Channel } from "../../../cashstorefronts/api/Channel.pb";
import type { ImageAsset } from "../../../cashstorefronts/api/Image.pb";
import type { OfferMetadata, OfferState, OfferType, RewardAmount } from "../../../cashstorefronts/api/Offer.pb";
import type { Image } from "../../../ui/Image.pb";
import type { OfferStatus } from "./offerStatus.pb";

export enum FilterEntityType {
  UNSPECIFIED = "UNSPECIFIED",
  CATEGORY = "CATEGORY",
  REDEMPTION = "REDEMPTION",
  OFFER = "OFFER",
}

export interface Business {
  /** the business profile token generated by cash-storefronts (BP_) */
  token?: string;
  external_ids?: ExternalBusinessIds;
  region?: Region;
  locale?: string;
  name?: string;
  logo?: Image;
  canonical_category?: string;
  features?: Feature[];
  /** features that are eligible for a specific request */
  eligible_features?: Feature[];
  image_assets?: ImageAsset[];
  tags?: string[];
  business_metadata?: BusinessMetadata;
  offers?: Offer[];
}

export interface ExternalBusinessIds {
  /** the bizzy token of the top level bizzy entity */
  bizzy_token?: string;
  /** the merchantein top level merchant token */
  merchantein_token?: string;
  afterpay_store_id?: string;
  afterpay_merchant_id?: string;
  /** the cash app pay brand id */
  cap_brand_id?: string;
}

export interface Offer {
  token?: string;
  types?: OfferType[];
  state?: OfferState;
  status?: OfferStatus;
  channels?: Channel[];
  business_token?: string;
  start_at_ms?: number;
  end_at_ms?: number;
  reward_amount?: RewardAmount;
  images?: ImageAsset[];
  offer_metadata?: OfferMetadata;
  in_app_browser_url?: string;
  business?: Business;
}

export interface Customer {
  customer_token?: string;
  display_name?: string;
  cashtag?: string;
  email?: string;
  sms?: string;
  region?: Region;
  rate_plan?: RatePlan;
  is_verified?: boolean;
  bio?: string;
  logo?: Image;
}

/**
 * AppFeature entities represent features within CashApp (ie: Add Cash, Taxes, etc). They allow parts of the
 * app to be searchable and directly linked to via a client route. Teen and region eligibility are handled
 * in the API. see https://www.notion.so/cashappcash/App-Features-in-Search-8461a12f211d41978aa64d7738d999c6
 * for more details
 */
export interface AppFeature {
  /** Unique identifier for app feature */
  app_feature_token?: string;
  /** The app feature's logo */
  logo?: Image;
  /** The name of the app feature translated by the localization framework */
  name?: string;
  /** Client route for the app feature */
  action_url?: string;
  /** Additional subtitle text translated by the localization framework */
  subtitle?: string;
}

export interface FilterEntity {
  filter_token?: string;
  logo?: Image;
  name?: string;
  title_key?: string;
  offer_count?: number;
  subtitle_key?: string;
  type?: FilterEntityType;
  /** 24 * 24 icon on the filter halfsheet */
  icon?: Image;
  lifeStyleImage?: Image;
}
